<template> 
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3"> 
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('update_personnel_account') }}</h1>  
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li> 
                    <li class="breadcrumb-item text-primary">{{ $t('accounts') }}</li>     
                    <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'PersonnelList' }">{{ $t('personnel') }}</router-link></li>     
                    <li class="breadcrumb-item text-gray-600">{{ $t('update_personnel_account') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li> 
                </ul> 
            </div>  
            <div class="d-flex align-items-center py-1">
                <router-link to="/PersonnelList">
                    <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> {{ $t('return_back_to_list') }}</span>
                    </button>
                </router-link> 
                &nbsp;
                <div class="dropdown" v-if="this.$isCredentialActive(14,'D')">
                    <button class="btn btn-light-info border border-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" id="personnelActions" type="button">
                    <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                    <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                    </svg></span>
                        {{ $t('actions') }}
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="personnelActions"> 
                        <li>
                            <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteItem()"><span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                            <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                            <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                            </svg>
                            </span>{{ $t('delete') }} </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div> 
        <div class="content flex-row-fluid mt-4" id="kt_content"> 
            <StatsBar :form-account="this.form"></StatsBar>        
            <div class="card-body">
                <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Account'}" data-bs-toggle="tab" href="#kt_accounting_1" target="_self"
                        @click="this.activeTab = 'Account'">
                            <h4> {{ $t('personnel_account') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item" v-if="this.$isModuleActive(3)">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Documents'}" data-bs-toggle="tab" href="#kt_accounting_4" target="_self"
                        @click="activateDocumentsSection()">
                            <h4> {{ $t('documents') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Details'}" data-bs-toggle="tab" href="#kt_accounting_5" target="_self"
                        @click="activateDetailsSection()">
                            <h4> {{ $t('details') }} </h4>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': this.activeTab == 'Parameters'}" data-bs-toggle="tab" href="#kt_accounting_6" target="_self"
                        @click="this.activeTab = 'Parameters'">
                            <h4> {{ $t('transfer_parameters') }} </h4>
                        </a>
                    </li>
                </ul>
            </div>
            <RequiredField></RequiredField>
            <div class="tab-content" id="myTabContent">
                <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel"> 
                    <form id="poliform" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                        <div class="d-flex flex-row row p-10">
                            <div class="row">
                                <div class="d-flex flex-column flex-row-auto col-lg-6">
                                    <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                        <div class="card-body pb-0"> 
                                                <div class="fv-row mb-7 row">                                                
                                                    <div class="col-lg-12" v-if="isViewAccountId">
                                                        <label class="fs-6 fw-bold form-label mt-3" :class="{'required': isViewAccountId}">
                                                            {{ $t('account_id') }}
                                                        </label>
                                                        <input type="text" class="form-control" name="accountID" v-model="form.account_id">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'name'">
                                                            {{ $t('name_surname') }}
                                                        </label>
                                                        <input type="text" class="form-control"
                                                            name="company_name" v-model="form.name" v-custom>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'country'">
                                                                <span>{{ $t('country') }}</span>
                                                            </label>
                                                            <Select2 v-model="form.country" :options="countryList" :settings="{width: '100%'}" @select="onChangeCountry($event)" name="country" v-custom/>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'position'">
                                                                <span>{{ $t('position') }}</span>
                                                            </label>
                                                            <Select2 v-model="form.personnel_position_id" :options="positionList" name="position" v-custom :settings="{ width: '100%'}"/>  
                                                        </div>
                                                    </div>
                                                </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column flex-row-auto col-lg-6">
                                    <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                        <div class="card-body pb-0"> 
                                                <div class="fv-row mb-6 row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'contact_name'">{{ $t('contact_name') }}
                                                        </label>
                                                        <input type="text" class="form-control" name="contact_name" v-model="form.contact_name" v-custom>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row fv-plugins-icon-container">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'email'">{{ $t('email') }}
                                                            </label>
                                                            <div class="input-group">
                                                                <input type="email" class="form-control" name="email" v-model="form.email" :class="{'border border-danger': isValidEmail == false}" v-custom>
                                                                <button v-if="!form.consent_approved_at" type="button" class="input-group-text m-0 text-hover-success cursor-pointer" id="basic-addon2"  
                                                                    @click="sendMailNotification()" :disabled="isGdprMailSending">
                                                                    {{ isGdprMailSending ?  $t('sending') :  $t('send_gdpr_consent') }}
                                                                </button>
                                                            </div>
                                                            <small class="fw-bold float-end text-end" v-if="form.consent_status" :class="{'text-success': form.consent_approved_at, 'text-danger': !form.consent_approved_at}">
                                                                <i class="bi bi-check-circle fs-8 text-success" v-if="form.consent_approved_at"></i>
                                                                <i class="bi bi-x-circle fs-8 text-danger" v-if="!form.consent_approved_at"></i>
                                                                
                                                                {{form.consent_status}}  <span v-if="form.consent_approved_at"> ({{previewDateTime(form.consent_approved_at)}}) </span>
                                                            </small>
                                                            <small class="text-danger" v-if="!isValidEmail && form.email !== null && form.email !== '' ">{{ $t('email_is_not_valid') }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'mobile_phone'">{{ $t('mobile_phone') }}
                                                            </label>
                                                            <div class="input-group">
                                                                <Select2 v-model="form.phone_country_code" :options="phoneMaskList" :settings="{width: '120px'}"/>
                                                                <input type="text" class="form-control" name="mobile_phone" v-model="form.mobile_phone" v-custom>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'phone'">
                                                                <span>{{ $t('phone') }}</span>
                                                            </label>
                                                            <div class="input-group">
                                                                <Select2 v-model="form.land_phone_country_code" :options="phoneMaskList" :settings="{width: '120px'}"/>
                                                                <input type="text" class="form-control" name="phone" v-model="form.phone" v-custom>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                        <div class="card-body pb-0"> 
                                                <div class="fv-row mb-6 row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'branch'">
                                                            <span>{{ $t('branch') }}</span>
                                                        </label>
                                                        <Select2 v-model="form.branch_id" :options="branchList" name="branch" v-custom :settings="{ width: '100%'}"/> 
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row mb-7">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'expense_center'">
                                                                <span>{{ $t('expense_center') }}</span>
                                                            </label>

                                                            <Select2 v-model="form.expense_center_id" :options="expenseCenterList" name="expense_center" v-custom :settings="{ width: '100%'}"/> 
                                                        </div>
                                                    </div>
                                                </div> 
                                        </div>
                                    </div>                    
                                </div>
                                <div class="col-lg-6">
                                    <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                        <div class="card-body pb-0"> 
                                                <div class="fv-row mb-6 row">                                                
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'account_number'">
                                                            <span>{{ $t('account_number') }}</span>
                                                        </label>
                                                            <input type="text" class="form-control" name="account_number" v-model="form.account_number" v-custom>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row mb-7">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'nino'">
                                                                <span>{{ $t('nino') }}</span>
                                                            </label>

                                                            <input type="text" class="form-control" name="nino" v-model="form.personnel_nino" v-custom>
                                                        </div>
                                                    </div>
                                                </div> 
                                        </div>
                                    </div>                    
                                </div>
                                <div class="col-lg-12">
                                    <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                        <div class="card-body pb-0"> 
                                                <div class="fv-row mb-6 row">
                                                    <GetAddress @address-selected="onSelectAddress" :account-type="5" v-if="userData.is_address_inquiry_active == 1 && userData.address_inquiry_sub_type == 2 && this.$isCredentialActive(14,'AI')"/>
                                                    <div class="col-lg-6">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'post_code'">{{ $t('post_code') }}                                                                                                             
                                                            </label>
                                                            <div class="input-group">
                                                                <input type="text" class="form-control" name="post_code" v-model="form.postcode" v-custom>
                                                                <button v-if="userData.is_address_inquiry_active == 1 && userData.address_inquiry_sub_type == 1  && this.$isCredentialActive(14,'AI')" type="button" class="input-group-text m-0 cursor-pointer text-hover-info" 
                                                                        id="basic-addon2" 
                                                                        @click="this.onFindAddressByPostCode()" 
                                                                        data-bs-toggle="modal" 
                                                                        data-bs-target="#kt_modal_search_address" 
                                                                        data-kt-menu-trigger="click" 
                                                                        data-kt-menu-placement="bottom-end"
                                                                        :disabled="this.form.postcode == null || this.form.postcode == ''">
                                                                    <i class="fas fa-search fs-4 me-3"></i> {{ $t('search_by_post_code') }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                    <div class="col-lg-6">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'address_code'">{{ $t('address_code') }}
                                                            </label>
                                                            <div class="input-group">
                                                                <input type="text" class="form-control" name="address_code" v-model="form.uprn" v-custom>
                                                                <button v-if="userData.is_address_inquiry_active == 1 && userData.address_inquiry_sub_type == 1  && this.$isCredentialActive(14,'AI')" type="button" class="input-group-text m-0 cursor-pointer text-hover-info" 
                                                                        id="basic-addon2" 
                                                                        @click="this.onFindAddressByAddressCode()" 
                                                                        data-bs-toggle="modal" 
                                                                        data-bs-target="#kt_modal_search_address_by_code" 
                                                                        data-kt-menu-trigger="click" 
                                                                        data-kt-menu-placement="bottom-end"
                                                                        :disabled="this.form.uprn == null || this.form.uprn == ''">
                                                                    <i class="fas fa-search fs-4 me-3"></i> {{ $t('search_by_address_code') }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'address'">
                                                                <span>{{ $t('address') }}</span>
                                                            </label>
                                                            <textarea class="form-control" name="address" v-model="form.address" v-custom></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'city'">
                                                                <span>{{$t('city')}}</span>
                                                            </label>
                                                            <input type="text" class="form-control" name="city" v-model="form.city" v-custom>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <div class="fv-row">
                                                            <label class="fs-6 fw-bold form-label mt-3" v-tag="'district'">{{ $t('district') }}
                                                            </label>
                                                            <input type="text" class="form-control" name="district" v-model="form.district" v-custom>
                                                        </div>
                                                    </div>
                                                </div> 
                                        </div>
                                    </div>                    
                                </div>
                                <div class="col-lg-12">
                                    <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                        <div class="card-body pb-0">
                                            <form id="kt_ecommerce_settings_general_form"
                                                class="form fv-plugins-bootstrap5 fv-plugins-framework">
                                                <div class="fv-row mb-7">
                                                    <label class="fs-6 fw-bold form-label mt-3" v-tag="'notes'">
                                                        <span>{{ $t('notes') }}</span>
                                                    </label>
                                                    <textarea class="form-control" name="notes" v-model="form.notes" v-custom></textarea>
                                                </div>
                                            </form>
                                        </div>
                                    </div>                    
                                </div>
                                <div class="col-lg-12 mt-0" v-if="this.$isCredentialActive(14,'U')">
                                    <div class="d-grid gap-2"> 
                                        <button type="button" class="btn btn-lg btn-primary mb-0" @click="this.saveData()" data-kt-indicator="on" :disabled="isValidEmail == false">
                                            <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                            </svg>
                                            </span>
                                                <strong v-if="!this.isProgressing"> {{ $t('update_personnel_account') }} </strong> 
                                                <span class="indicator-progress" v-if="this.isProgressing">
                                                    {{ $t('saving_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_4" role="tabpanel">
                    <div class="row p-10" v-if="this.activeTab == 'Documents'">
                        <FileManager :location="1" :locationtype="5" :upload_source="4" ref="FileManagerComponent"></FileManager>
                    </div>
                </div>
                <div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_5" role="tabpanel">
                    <div class="row p-10" v-if="this.activeTab == 'Details'">
                        <AccountBankDetails ref="AccountBankDetails"></AccountBankDetails>
                    </div>
                </div>
                <div class="card card-xxl-stretch tab-pane fade" id="kt_accounting_6" role="tabpanel">
                    <div class="row" v-if="this.activeTab == 'Parameters'">
                        <AccountTransferParameters ref="AccountTransferParameters"></AccountTransferParameters>
                    </div>
                </div>
            </div>
        </div>

        <!-- SEARCH ADDRESS BY POSTCODE RESULT -->
        <div class="modal fade" id="kt_modal_search_address" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <FindAddressByPostCode ref="FindAddressByPostCode" :post-code="this.form.postcode" :account-type="5"></FindAddressByPostCode>
        </div>
        <!-- SEARCH ADDRESS BY ADDRESS CODE RESULT -->
        <div class="modal fade" id="kt_modal_search_address_by_code" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <FindAddressByAddressCode ref="FindAddressByAddressCode" :address-code="this.form.uprn" :account-type="5"></FindAddressByAddressCode>
        </div>
    </div>
</template>

<script>
import axios from "axios"; 

import moment from 'moment';
import FindAddressByPostCode from '../../Accounts/Modals/FindAddressByPostCode.vue';
import FindAddressByAddressCode from '../../Accounts/Modals/FindAddressByAddressCode.vue';
import AccountBankDetails from '../../Accounts/Modals/AccountBankDetails.vue';
import AccountTransferParameters from '../Modals/AccountTransferParameters.vue';
export default {
  name: "PersonnelUpdate",
  components:{
    FindAddressByPostCode, FindAddressByAddressCode,AccountBankDetails, AccountTransferParameters
  },
  data() {
    return { 
      userData: this.$getUser(),
      positionList: [],
      companyTypeList: [],
      countryList: [],
      cityList: [],
      addressList: [],
      branchList: [],
      expenseCenterList: [],
      phoneMaskList: [],
      isProgressing: false,
      form: {
        id: null,
        name: null,
        company_type_id: null,
        customer_company_type_id: null,
        account_type: null,
        account_id: null,
        qr_code: null,
        notes: null, 
        account_number: null,
        contact_name: null,
        email: null,
        mobile_phone: null,
        phone: null,
        postcode: null,
        address: null,
        address_id: '-1',
        country: '-1',
        city: null, 
        vat_number: null,
        payment_value: null,
        isVATNumberExist: 'false',
        personnel_nino: null,
        personnel_position_id: '-1',
        branch_id: '-1',
        expense_center_id: '-1',
        accounting_plan: null,
        phone_country_code: null,
        land_phone_country_code: null,
        district: null,
        x_coordinate: 0,
        y_coordinate: 0,
        uprn: null,
        udprn: null,
        consent_approved_at: null,
        consent_status: null
      },
      isViewAccountId: false,
      activeTab: 'Account',
      menuSelection: '/PersonnelHelppage',
      iconView : false,
      isGdprMailSending: false
    };
  },
  computed: {
		isValidEmail() {
			return (this.form.email == null || this.form.email == '' || this.form.email == undefined) ? null : /^[^@]+@\w+(\.\w+)+\w$/.test(this.form.email);
		},
        previewDateTime(){
            return (value)=>{
                if (value) {
                    return moment(new Date(value)).format('DD.MM.YYYY HH:mm')
                }
            }
        },
  },
  methods: {
    getData(isRefresh) {
        this.$Progress.start();
        this.addressList = [];
        this.addressList.unshift({ id: '-1', text: this.$t('select_an_option')});
        const params = {
            id: this.$getSessionStorage('record_id'),
            session_id: this.$getUser().session_id
        };
        axios.post('api/CompanyAccounts/GetAccountById', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.form.id = response.data.id;
            this.form.name = this.$unlock(response.data.name);
            this.form.account_id = this.$unlock(response.data.account_id);
            this.form.qr_code = this.$unlock(response.data.qr_code);
            this.form.account_number = this.$unlock(response.data.personnel_account_number);
            this.form.contact_name = this.$unlock(response.data.personnel_contact_name);
            this.form.email = this.$unlock(response.data.personnel_email);
            this.form.mobile_phone = this.$unlock(response.data.personnel_mobile_phone);
            this.form.phone = this.$unlock(response.data.personnel_phone);
            this.form.postcode = this.$unlock(response.data.personnel_postcode);
            this.form.address = this.$unlock(response.data.personnel_address);
            this.form.country = this.$unlock(response.data.personnel_country);
            this.form.city = this.$unlock(response.data.personnel_city);
            this.form.district = this.$unlock(response.data.personnel_district);
            this.form.x_coordinate = this.$unlock(response.data.personnel_x_coordinate);
            this.form.y_coordinate = this.$unlock(response.data.personnel_y_coordinate);
            this.form.uprn = this.$unlock(response.data.personnel_uprn);
            this.form.udprn = this.$unlock(response.data.personnel_udprn);
            this.form.personnel_nino = this.$unlock(response.data.personnel_nino); 
            this.form.phone_country_code = this.$unlock(response.data.personnel_phone_country_code);
            this.form.land_phone_country_code = this.$unlock(response.data.personnel_land_phone_country_code);
            this.form.personnel_company_type_id = response.data.personnel_company_type_id;
            this.form.payment_value = response.data.personnel_payment_value;
            if(this.form.country == null || this.form.country == '') this.form.country = '-1';
            this.form.x_coordinate = (this.form.x_coordinate == null || this.form.x_coordinate == '') ? 0 : Math.abs(parseFloat(this.form.x_coordinate.replace(',', '.')));
            this.form.y_coordinate = (this.form.y_coordinate == null || this.form.y_coordinate == '') ? 0 : Math.abs(parseFloat(this.form.y_coordinate.replace(',', '.')));
            this.form.notes = response.data.notes;
            this.form.account_type = response.data.account_type;            
            this.form.consent_approved_at = response.data.consent_approved_at;
            this.form.consent_status = response.data.consent_status;
            this.form.personnel_position_id = (response.data.personnel_position_id == null || response.data.personnel_position_id == '') ? '-1': response.data.personnel_position_id;
            this.form.branch_id = (response.data.branch_id == null || response.data.branch_id == '') ? '-1': response.data.branch_id;
            this.form.expense_center_id = (response.data.expense_center_id == null || response.data.expense_center_id == '') ? '-1': response.data.expense_center_id;
            if(this.form.vat_number !== null && this.form.vat_number !== ''){
                this.form.isVATNumberExist =  'true';
            }
            if(!isRefresh) this.getLists();
            else this.$Progress.finish();   
        })
        .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
        });  
    },
    getLists() {
        this.positionList = []; 
        const parameters = {
            session_id: this.$getUser().session_id,
            list_name:["branch", "account_setting", "expense_center","country"],
            account_type: 5, // yalnızca account settings listesi çekilecek ise gerekli
            country_code: this.$getUser().company_country_code, // yalnızca Company Types listesi çekilecek ise gerekli
            list_type: 3, // Personnel Position List: 3          
            get_access_status: 0
        };  
        const requestOne =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/Helper/GetLists', parameters, {'Content-Type': 'application/json'}); 
        const requestThree =  axios.post('/api/Helper/GetPhoneMasks', parameters, {'Content-Type': 'application/json'}); 

        axios.all([requestOne, requestTwo, requestThree]).then(axios.spread((...responses) => {
                this.branchList = responses[0].data.branch;
                this.expenseCenterList = responses[0].data.expense_center;
                this.phoneMaskList = responses[2].data;
                this.countryList = responses[0].data.country; 
                this.positionList = responses[1].data;
                if (responses[0].data.account_setting.is_default == false) {
                    this.isViewAccountId = true;
                }
            this.positionList.unshift({ id: '-1', text: this.$t('select_an_option')});
            this.countryList.unshift({ id: '-1', text: this.$t('select_an_option')}); 
            this.$Progress.finish(); 
            })
        )
        .catch((error) => {
            console.error(error);
            this.$Progress.finish();
        });
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/PersonnelHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    saveData() {
      this.$checkSelect2Validation('poliform');  
      if(!document.forms['poliform'].reportValidity()){
        return;
      }
      this.isProgressing = true;
      const params ={
        id:this.form.id,
        name:this.form.name,
        customer_company_type_id:this.form.customer_company_type_id,
        account_type:this.form.account_type,
        account_id:this.form.account_id,
        qr_code:this.form.qr_code,
        notes:this.form.notes,
        account_number:this.form.account_number,
        contact_name:this.form.contact_name,
        email:this.form.email,
        mobile_phone:this.form.mobile_phone,
        phone:this.form.phone,
        postcode:this.form.postcode,
        address:this.form.address,
        address_id:this.form.address_id,
        country:this.form.country == '-1' ? null : this.form.country,
        city:this.form.city,
        vat_number:this.form.vat_number,
        payment_value:this.form.payment_value,
        isVATNumberExist:this.form.isVATNumberExist,
        personnel_nino:this.form.personnel_nino,
        personnel_position_id: this.form.personnel_position_id == '-1' ? null : this.form.personnel_position_id,
        branch_id:this.form.branch_id == '-1' || this.form.branch_id == ''  ? null : this.form.branch_id,
        expense_center_id: this.form.expense_center_id == '-1' ? null : this.form.expense_center_id,
        accounting_plan: this.form.accounting_plan,
        phone_country_code:this.form.phone_country_code,
        land_phone_country_code:this.form.land_phone_country_code,
        district:this.form.district,
        x_coordinate:this.form.x_coordinate,
        y_coordinate:this.form.y_coordinate,
        uprn:this.form.uprn,
        udprn:this.form.udprn,
      };    
      params.session_id = this.$getUser().session_id;
      const that = this;
    axios.post('api/CompanyAccounts/UpdateAccount', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null && response.data.length == 36){  
                this.$swal(this.$t('success'), this.$t('data_saved_succesfully'), 'success');  
            }
        })
        .catch(() => { 
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), 'error');
        })
        .finally(() => { 
            setTimeout(() => {
                that.isProgressing = false;
            }, 500);
        }); 
    },
    deleteItem(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_delete_this_data'),
            confirmButtonColor: '#f1416c',
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('yes'),
            icon: 'warning'
        }).then((result) => { 
            if (result.isConfirmed) {
            const params = {
                session_id: this.$getUser().session_id,
                id: this.form.id
            }; 
            axios.post('api/CompanyAccounts/DeleteAccount', params, {'Content-Type': 'application/json'})
                .then((response) => { 
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                        this.$router.push({ name: 'PersonnelList' });
                    }
                })
                .catch(() => { 
                    this.$swal(this.$t('failed'), this.$t('data_could_not_be_deletedplease'), 'error');   
                });  
            }
        })   
    },
    activateDocumentsSection(){
        this.activeTab = 'Documents'; 
    },
    activateDetailsSection(){
        this.activeTab = 'Details'; 
    },
    onFindAddressByPostCode(){  
        this.$refs.FindAddressByPostCode.getData();
    },
    onFindAddressByAddressCode(){  
        this.$refs.FindAddressByAddressCode.getData();
    },
    onSelectAddressSearchResult(item){
        this.form.address = item.ADDRESS;
        this.form.city = item.POST_TOWN;
        this.form.district = item.LOCAL_CUSTODIAN_CODE_DESCRIPTION;
        this.form.x_coordinate = item.X_COORDINATE;
        this.form.y_coordinate = item.Y_COORDINATE;
        this.form.uprn = item.UPRN;
        this.form.udprn = item.UDPRN;
        this.form.postcode = item.POSTCODE;
    },
    onSelectAddress(item) {
        if(item.id == '-1') return;
        this.form.address = item.fullAddress;
        this.form.city = item.town_or_city;
        this.form.district = item.district;
        this.form.postcode = item.postcode;
    },
    async sendMailNotification() { 
        this.$swal.fire({
            title: "Are you sure you want to sent GDPR Consent to "+ this.form.email + " ?",
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('save'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                this.isGdprMailSending = true;
                const parameters = {
                    session_id: this.$getUser().session_id,
                    id: this.form.id,
                    country_code: this.$getUser().company_country_code,
                    lang: localStorage.getItem('locale') || this.$i18n.locale || 'en'
                };  
                const that = this;
                axios.post('/api/Notification/SendMailNotification', parameters, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                        this.getLists(true);
                        this.$swal(this.$t('success'), this.$t('gdpr_notification_sent_successfully'), 'success'); 
                    }
                })
                .catch((error) => {
                    that.isGdprMailSending = false;
                    console.error(error);
                })
                .finally(function(){
                    that.isGdprMailSending = false;
                });
            }
        });
    }
  },
  created() {
    this.helpPageViewIcon();
    this.getData();
  },
};
</script>